export {
  templateBlogPostSchema,
  type EnrichedBlogPost as TemplateBlogPost,
} from "../schemas/blog-post";
